const GET_USER_SUBSCRIPTION = 'core/userSubscriptions/GET_USER_SUBSCRIPTION';
const GET_USER_SUBSCRIPTION_COMPLETED = 'core/userSubscriptions/GET_USER_SUBSCRIPTION_COMPLETED';
const GET_USER_SUBSCRIPTION_FAILED = 'core/userSubscriptions/GET_USER_SUBSCRIPTION_FAILED';
const UPDATE_USER_SUBSCRIPTION = 'core/userSubscriptions/UPDATE_USER_SUBSCRIPTION';
const UPDATE_USER_SUBSCRIPTION_COMPLETED = 'core/userSubscriptions/UPDATE_USER_SUBSCRIPTION_COMPLETED';
const UPDATE_USER_SUBSCRIPTION_FAILED = 'core/userSubscriptions/UPDATE_USER_SUBSCRIPTION_FAILED';

export {
  GET_USER_SUBSCRIPTION,
  GET_USER_SUBSCRIPTION_COMPLETED,
  GET_USER_SUBSCRIPTION_FAILED,
  UPDATE_USER_SUBSCRIPTION,
  UPDATE_USER_SUBSCRIPTION_COMPLETED,
  UPDATE_USER_SUBSCRIPTION_FAILED
};
